<template>
  <v-dialog v-model="dialog" max-width="600px" persistent scrollable>
    <v-card>
      <v-card-title>{{ $t("Find Patient") }}</v-card-title>

      <v-card-text class="pb-1">
        <v-container>
          <v-form ref="form" lazy-validation dense>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="patId"
                  label="Patient ID"
                  v-on:keyup.13="search"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="patName"
                  label="Patient Name"
                  v-on:keyup.13="search"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>

          <v-btn class="mt-2 pb-0" @click="search" :loading="loading" dense>
            {{ $t("search") }}
          </v-btn>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text style="height: 300px" class="pb-0">
				<v-list subheader two-line flat>
					<v-list-item-group
						v-model="selected"
					>
						<template v-for="(item, i) in patients">
							<v-list-item :key="`pat-${i}`">
								<template v-slot:default="{ active, }">
									<v-list-item-action>
										<v-checkbox
											:input-value="active"
											color="primaryLight"
										></v-checkbox>
									</v-list-item-action>

									<v-list-item-content>
										<v-list-item-title>{{ rmCarets(item.patName) }}</v-list-item-title>
										<v-list-item-subtitle>{{ item.patId + " (" + item.patSex + ")" }}</v-list-item-subtitle>
									</v-list-item-content>
								</template>
							</v-list-item>
						</template>
					</v-list-item-group>
				</v-list>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" text>{{ $t("close") }}</v-btn>
        <v-btn color="primaryLight" @click="update" text>{{ $t("select") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import EventBus from "../../../event-bus";

export default {
  name: "FindPatient",
  data: () => ({
    dialog: true,
		selected: [],
    patients: [],
    patId: "",
    patName: "",
		loading: false,
  }),
  methods: {
    sendError(error) {
      if (error.response) {
        if (
          error.response.status == 500 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }
    },
		rmCarets(src) {
			if (typeof src !== "undefined") {
				return src.replaceAll("^", " ").trim();
			} else {
				return "";
			}
		},
    addWildcards(value) {
      if (value !== "") {
        return '*' + value + '*';
      } else {
        return "";
      }
    },
		search() {
			this.loading = true;
			axios({
        url: "/api/v1/dicom/find/patients",
        method: "POST",
        data: {
					patName: this.addWildcards(this.patName),
					patId: this.addWildcards(this.patId),
					limit: 50,
				},
      })
        .then((resp) => {
          this.loading = false;

          if (
            !resp.data ||
            !resp.data.status ||
            !(resp.data.status == "done")
          ) {
            this.sendError(resp.data.description);
          } else {
						this.patients = resp.data.patients;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.sendError(error);
        });
		},
    close() { 
			this.$emit("onClose");
		},
    update() {
			this.$emit("onUpdate", this.patients[this.selected]);
		}
  },
};
</script>

<style scoped>
</style>